import {Injectable} from '@angular/core';
import {Subject} from "rxjs";
import {GoogleMapsService} from "./google-map.service";
import {
  Partecipant
} from "../../classes/common/partecipant";
import {Poi} from "../../classes/common/poi";

@Injectable({
  providedIn: 'root'
})
export class MainMapService {

  readonly MAP_NAME: string = "main";

  static infotrafficLabel: string; // label etichetta infotraffico
  static infotrafficImage: string; // Url immagine anteprima infotraffico
  static roadMapLabel: string; // label etichetta read map
  static roadMapImage: string; // Url immagine anteprima road map
  static satelliteMapLabel: string; // label etichetta mappa satellitare
  static satelliteMapImage: string; // Url immagine anteprima mappa satellitare
  static isMobile: boolean;

  mapType: string;
  map: any;
  participantMarkers: any[] = [];
  poiMarkers: any[] = [];
  infoWindow: any;
  circle: any;
  selectedMarker: any;

  onSelectMarker = new Subject<any>();
  onSelectMarker$ = this.onSelectMarker.asObservable();

  onUpdateAutoFollow = new Subject<any>();
  onUpdateAutoFollow$ = this.onUpdateAutoFollow.asObservable();

  buttonMapType_1: any;
  buttonMapType_2: any;
  infoTrafficEnabled: boolean = true;
  lastAutoZoomTime: number = 0;
  autoZoomPausedByUser: boolean = false;
  cambioDaCodice: boolean = false;


  needResize: boolean;

  static currentZoom: number;
  static currentCenter: any;
  static currentInfotraffic: boolean;
  static currentMapType:  string;
  static initCount: number = -1;

  static labelVisible: boolean = true;
  static popupVisible: boolean = true;
  static marginSize: number = 4;
  static autoFollow: boolean = undefined;
  static primoAvvio: boolean = false;

  constructor(
    public googleMaps: GoogleMapsService
  ) {
  }

  async initMap(
    mapType: string,
    infotrafficLabel: string,
    infotrafficImage: string,
    roadMapLabel: string,
    roadMapImage: string,
    satelliteMapLabel: string,
    satelliteMapImage: string,
    lightInit: boolean,
    isMobile?: boolean
  ) {
    MainMapService.infotrafficLabel = infotrafficLabel;
    MainMapService.infotrafficImage = infotrafficImage;
    MainMapService.roadMapLabel = roadMapLabel;
    MainMapService.roadMapImage = roadMapImage;
    MainMapService.satelliteMapLabel = satelliteMapLabel;
    MainMapService.satelliteMapImage = satelliteMapImage;
    MainMapService.isMobile = isMobile;

    this.mapType = mapType;
    this.clearMap();
    await this.googleMaps.isReady(); // Attende che google sia caricato
    this.googleMaps.clearMap();
    this.map = this.googleMaps.getMap();
    let mapContainer: any = document.getElementById("main-map");
    if(mapContainer){
      mapContainer.appendChild(this.googleMaps.getDivMap());
      this.googleMaps.setCurrentMap(this.MAP_NAME);
    }
    const listenerRef: any = this.map.addListener('rightclick', (event: any) => {
      if (!this.cambioDaCodice) {
        this.pauseAutoZoomByUser(); // azione dell’utente
      }
      this.drawSelectMarker(event.latLng.lat(), event.latLng.lng());
    });
    this.googleMaps.addListener(listenerRef, this.MAP_NAME);
    const listenerClick: any = this.map.addListener('click', (event: any) => {
      if (!this.cambioDaCodice) {
        this.pauseAutoZoomByUser(); // azione dell’utente
      }
      this.googleMaps.unspiderfyMarkers(MainMapService.popupVisible);
      if(this.selectedMarker) this.selectedMarker.map = null;
      this.closeInfoWindow();
    });
    this.googleMaps.addListener(listenerClick, this.MAP_NAME);
    const listenerZoomChange: any = this.map.addListener("zoom_changed", () => {
      MainMapService.currentZoom = this.map.getZoom();
    });
    this.googleMaps.addListener(listenerZoomChange, this.MAP_NAME);
    const listenerCenterChange: any = this.map.addListener("center_changed", (event: any) => {
      if (!this.cambioDaCodice) {
        this.pauseAutoZoomByUser(); // azione dell’utente
      }
      MainMapService.currentCenter = this.map.getCenter();
    });
    this.googleMaps.addListener(listenerCenterChange, this.MAP_NAME);
    if(!lightInit){
      this.infoWindow = new GoogleMapsService.google.maps.InfoWindow();
      this.infoWindow.setContent(document.getElementById("main-map-infowindow") as HTMLElement);
      this.infoWindow.setZIndex(4000);
    }
    MainMapService.initCount++;
    this.map.setOptions({
      center: MainMapService.currentCenter || {lat: 41.8933203, lng: 12.4829321},
      zoom: MainMapService.currentZoom || 6,
      fullscreenControl: false,
      zoomControl: !MainMapService.isMobile,
      streetViewControl: false,
      mapTypeControl: false,
      clickableIcons: false,
      mapTypeId: MainMapService.currentMapType || GoogleMapsService.google.maps.MapTypeId.ROADMAP
    });
    if(MainMapService.currentInfotraffic){
      this.googleMaps.enableInfoTraffic();
    }else{
      this.googleMaps.disableInfoTraffic();
    }
    this.setMapTypeControls();
  }

  clearMap(){
    this.selectedMarker = undefined;
    this.poiMarkers = [];
    this.participantMarkers = [];
  }

  pauseAutoZoomByUser() {
    if (!MainMapService.autoFollow) return;
    this.autoZoomPausedByUser = true;
    this.onUpdateAutoFollow.next({pause: true, status: MainMapService.autoFollow});
  }

  changeZoom(delta: number){
    let zoom: number = this.map.getZoom();
    this.map.setZoom(zoom + delta);
  }

  resizeMap(){
    let bounds: any = new GoogleMapsService.google.maps.LatLngBounds();
    for (let i = 0; i < this.participantMarkers.length; i++) {
      const marker = this.participantMarkers[i];

      if (marker.map && marker.position) {
        bounds.extend(marker.position);
      }
    }
    for (let i = 0; i < this.poiMarkers.length; i++) {
      const marker = this.poiMarkers[i];

      if (marker.map && marker.position) {
        bounds.extend(marker.position);
      }
    }
    if(!bounds.isEmpty()){
      this.map.fitBounds(bounds, 50);
      setTimeout(() => {
        if(this.map.getZoom() > 16){
          this.map.setZoom(16);
        }
      }, 200)
    }
  }

  setCenter(lat: number, lng: number){
    this.map.setCenter({lat: lat, lng: lng});
  }

  setMapType(type: string){
    this.map.setMapTypeId(type);
  }

  getMapType(){
    return this.map.getMapTypeId();
  }

  private async setMapTypeControls(){
    // console.log('main-map service setMapTypeControls()');

    const size: string = MainMapService.isMobile ? '54px' : '75px';
    if(!this.buttonMapType_1){
      this.buttonMapType_1 = document.createElement('div');
      let controlUIMap = document.createElement('div');
      controlUIMap.style.height = size;
      controlUIMap.style.width = size;
      controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.satelliteMapImage + ")";
      controlUIMap.style.backgroundSize = size + " " + size;
      controlUIMap.style.border = '2px solid #fff';
      controlUIMap.style.borderRadius = '5px';
      controlUIMap.style.cursor = 'pointer';
      controlUIMap.style.marginRight = MainMapService.isMobile ? '8px' : '10px';
      this.buttonMapType_1.style.marginBottom = "5px";
      this.buttonMapType_1.appendChild(controlUIMap);
      let controlTexMap = document.createElement('div');
      controlTexMap.style.color = "#fff";
      controlTexMap.style.fontFamily = 'Roboto,Arial,sans-serif';
      controlTexMap.style.fontSize = MainMapService.isMobile ? '8px' : '10px';
      controlTexMap.style.lineHeight = '38px';
      controlTexMap.style.paddingLeft = '5px';
      controlTexMap.style.paddingRight = '5px';
      controlTexMap.style.marginTop = MainMapService.isMobile ? '20px' : '40px';
      controlTexMap.style.textOverflow = 'ellipsis';
      controlTexMap.style.overflow = 'hidden';
      controlTexMap.style.whiteSpace = 'nowrap';
      controlTexMap.innerHTML = MainMapService.satelliteMapLabel;
      this.buttonMapType_1.addEventListener('click', () => {
        let mapTypeId: string = this.map.getMapTypeId();
        if (mapTypeId == GoogleMapsService.google.maps.MapTypeId.HYBRID) {
          controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.satelliteMapImage + ")";
          controlUIMap.style.backgroundSize = size + " " + size;
          controlTexMap.innerHTML = MainMapService.satelliteMapLabel;
          MainMapService.currentMapType = GoogleMapsService.google.maps.MapTypeId.ROADMAP;
        } else {
          controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.roadMapImage + ")";
          controlUIMap.style.backgroundSize = size + " " + size;
          controlTexMap.innerHTML = MainMapService.roadMapLabel;
          MainMapService.currentMapType = GoogleMapsService.google.maps.MapTypeId.HYBRID;
        }
        this.map.setMapTypeId(MainMapService.currentMapType);
      });
      controlUIMap.appendChild(controlTexMap);
    }
    if(!this.buttonMapType_2){
      this.buttonMapType_2 = document.createElement('div');
      let controlUITraffic = document.createElement('div');
      controlUITraffic.style.height = size;
      controlUITraffic.style.width = size;
      controlUITraffic.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.infotrafficImage + ")";
      controlUITraffic.style.backgroundSize = size + " " + size;
      controlUITraffic.style.border = '2px solid #fff';
      controlUITraffic.style.borderRadius = '5px';
      controlUITraffic.style.cursor = 'pointer';
      controlUITraffic.style.marginRight = MainMapService.isMobile ? '8px' : '10px';
      controlUITraffic.style.marginBottom = "5px";
      this.buttonMapType_2.appendChild(controlUITraffic);
      let controlTextTraffic = document.createElement('div');
      controlTextTraffic.style.color = "#fff";
      controlTextTraffic.style.fontFamily = 'Roboto,Arial,sans-serif';
      controlTextTraffic.style.fontSize = MainMapService.isMobile ? '8px' : '10px';
      controlTextTraffic.style.lineHeight = '38px';
      controlTextTraffic.style.paddingLeft = '5px';
      controlTextTraffic.style.paddingRight = '5px';
      controlTextTraffic.style.textOverflow = 'ellipsis';
      controlTextTraffic.style.overflow = 'hidden';
      controlTextTraffic.style.whiteSpace = 'nowrap';
      controlTextTraffic.style.marginTop = MainMapService.isMobile ? '20px' : '40px';
      controlTextTraffic.innerHTML = MainMapService.infotrafficLabel;
      this.buttonMapType_2.addEventListener('click', () => {
        if(MainMapService.currentInfotraffic){
          MainMapService.currentInfotraffic = false;
          this.googleMaps.disableInfoTraffic();
          controlUITraffic.style.borderColor = "#fff";
        }else{
          MainMapService.currentInfotraffic = true;
          this.googleMaps.enableInfoTraffic();
          controlUITraffic.style.borderColor = "#32aadf";
        }
      });
      controlUITraffic.appendChild(controlTextTraffic);
    }
    this.map.controls[GoogleMapsService.google.maps.ControlPosition.RIGHT_BOTTOM].push(this.buttonMapType_1);
    this.map.controls[GoogleMapsService.google.maps.ControlPosition.RIGHT_BOTTOM].push(this.buttonMapType_2);

  }

  static clearService(){
    MainMapService.initCount = -1;
    MainMapService.currentZoom = undefined;
    MainMapService.currentCenter = undefined;
    MainMapService.currentInfotraffic = undefined;
    MainMapService.currentMapType = undefined;
  }

  requestResize(consumed?: boolean){
    this.needResize = !consumed;
  }

  isToResize(): boolean{
    return this.needResize;
  }

  // Dice se la mappa è già visibile
  isCurrentMap(){
    return this.googleMaps.currentMap === this.MAP_NAME;
  }

  closeInfoWindow(){
    if(this.infoWindow) this.infoWindow.close();
    if(this.circle) this.googleMaps.removeCircle(this.circle, this.MAP_NAME);
    if(this.selectedMarker) this.googleMaps.removeMarker(this.selectedMarker, this.MAP_NAME);
  }

  getMarkersAtClick(event) {
    const clickX = event.clientX;
    const clickY = event.clientY;
    const overlappingMarkers = [];

    this.participantMarkers.forEach(marker => {
      const rect = marker.content.getBoundingClientRect();

      const isClickInside =
        clickX >= rect.left &&
        clickX <= rect.right &&
        clickY >= rect.top &&
        clickY <= rect.bottom;

      if (isClickInside) {
        overlappingMarkers.push(marker);
      }
    });

    this.poiMarkers.forEach(marker => {
      const rect = marker.content.getBoundingClientRect();

      const isClickInside =
        clickX >= rect.left &&
        clickX <= rect.right &&
        clickY >= rect.top &&
        clickY <= rect.bottom;

      if (isClickInside) {
        overlappingMarkers.push(marker);
      }
    });

    return overlappingMarkers;
  }



  drawSelectMarker(lat: number, lng: number){
    if(this.selectedMarker?.map) this.selectedMarker.map = null;
    this.selectedMarker = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
      zIndex: 10000,
      map: this.map,
      position: { lat, lng },
      content: this.googleMaps.createSelectedMarker()
    });
    this.selectedMarker.id = 'seleceted-marker';
    this.googleMaps.addMarker(this.selectedMarker, this.MAP_NAME);
    this.onSelectMarker.next({type: 'selected-marker', id: this.selectedMarker.id, position: {lat: lat, lng:lng}});
    if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
    this.infoWindow.open(this.map, this.selectedMarker);
    this.selectedMarker.addListener("click", () => {
      this.onSelectMarker.next({type: 'selected-marker', id: this.selectedMarker.id, position: {lat: lat, lng:lng}});
      if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
      this.infoWindow.open(this.map, this.selectedMarker);
    });
  }



  drawParticipantMarkers(participants: Partecipant[]){
    this.participantMarkers = [];
    for(let i=0; i<participants.length; i++){
      this.drawSingleParticipantMarker(participants[i]);
    }
  }

  drawSingleParticipantMarker(participant: Partecipant){
    if(participant.virtualPosition && participant.virtualPosition.latitude && participant.virtualPosition.longitude){
      const coord: any = {
        lat: participant.virtualPosition.latitude,
        lng: participant.virtualPosition.longitude
      };

      let marker: any = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
        zIndex: 10,
        position: coord,
        content: MainMapService.createParticipantMarker(),
        map: this.map
      });
      marker.id = participant._id;
      marker.type = 'participant';

      this.participantMarkers.push(marker);

      this.updateParticipantMarker(participant);
      this.googleMaps.addMarker(marker, this.MAP_NAME);

      marker.addEventListener('click', (e: any) => {
        e.stopPropagation();
        this.closeInfoWindow();
        if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
        let click_in_spider: boolean;
        if(this.googleMaps.markers_in_spider?.find(elem => elem.id === participant._id)){
          click_in_spider = true;
        }
        this.googleMaps.unspiderfyMarkers(MainMapService.popupVisible);

        if(click_in_spider){
          marker.zIndex = 1000;
          this.onSelectMarker.next({type: 'participant', id: marker.id});
          if(!MainMapService.isMobile) this.infoWindow.open(this.map, marker);
          return;
        }else{
          const clickX = e.clientX;
          const clickY = e.clientY;

          this.googleMaps.markers_in_spider = this.getMarkersAtClick(e);
          if (this.googleMaps.markers_in_spider.length > 1) {
            // include anche il marker cliccato
            if(this.googleMaps.markers_in_spider.length > 12) {
              this.googleMaps.spiderfyMoltiMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }else{
              this.googleMaps.spiderfyMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }
          } else {
            this.onSelectMarker.next({type: 'participant', id: marker.id});
            if(!MainMapService.isMobile) this.infoWindow.open(this.map, marker);
          }
        }
      });
    }
  }

  static createParticipantMarker() {
    const markerContent = document.createElement("div");
    markerContent.innerHTML = `
<div class="mappa_custom-marker">
  <div class="mappa_marker-label"></div>
  <div class="mappa_marker-scalable">
    <div class="mappa_marker">
      <div class="mappa_label_number"></div>
      <div class="mappa_internal_img"></div>
      <div class="mappa_arrow-icon">
        <svg class="mappa_arrow-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.16496 19.5025L10.5275 2.99281C11.1178 1.66906 12.8822 1.66906 13.4725 2.99281L20.835 19.5025C21.5021 20.9984 20.0209 22.5499 18.6331 21.809L12.7294 18.657C12.2702 18.4118 11.7298 18.4118 11.2706 18.657L5.36689 21.809C3.97914 22.5499 2.49789 20.9984 3.16496 19.5025Z" fill="#aaa"/>
        </svg>
      </div>
      <div class="mappa_etichetta_number"></div>
      <div class="mappa_din1_state"></div>
      <div class="mappa_v-marker-border"></div>
      <div class="mappa_v-marker"></div>
    </div>
  </div>
</div>
`;
    return markerContent.firstElementChild;
  }

  updateParticipantMarker(participant: Partecipant){
    let marker: any = this.participantMarkers.find((elem: any) => {
      return elem.id === participant._id;
    });
    if(marker){ // modifico il marker esistente
      // Aggiorno posizione
      marker.position = {lat: participant.virtualPosition.latitude, lng: participant.virtualPosition.longitude};

      // setto immagine se necessario
      const element: any = marker.content.querySelector('.mappa_internal_img');
      if(participant.image){
        element.style.backgroundImage = `url(${participant.image})`;
      }else{
        element.style.backgroundImage = 'none';
      }

      // setto label number
      const etichetta: any = marker.content.querySelector('.mappa_etichetta_number');
      let label_elem = marker.content.querySelector(".mappa_label_number");
      etichetta.textContent = `${participant.label_number || ''}`;
      label_elem.textContent = `${participant.label_number || ''} `;
      if(!MainMapService.labelVisible || !participant.label_number){
        label_elem.style.display = 'none';
        etichetta.style.display = 'none';
      }else{
        label_elem.style.display = 'block';
        if(participant.image){
          etichetta.style.display = 'block';
        }else{
          etichetta.style.display = 'none';
        }
      }

      const angle: any = marker.content.querySelector(".mappa_arrow-svg");
      angle.style.transform = `rotate(${participant.virtualPosition.angle || 0}deg)`;
      if(participant.virtualPosition.tripStatus){
        marker.content.querySelector(".mappa_marker").style.backgroundColor = '#0ca000';
        marker.content.querySelector(".mappa_v-marker").style.borderTopColor = '#0ca000';
      }else{
        marker.content.querySelector(".mappa_marker").style.backgroundColor = '#fa2200';
        marker.content.querySelector(".mappa_v-marker").style.borderTopColor = '#fa2200';
      }
      const din1: any = participant.getIn1State();
      const din1_elem: any = marker.content.querySelector(".mappa_din1_state");
      if(din1 !== undefined){
        din1_elem.style.display = 'unset';
        din1_elem.style.backgroundColor = din1 ? '#fad401' : '#8f8d8d';
      }else{
        din1_elem.style.display = 'none';
      }

      let label_string: any = marker.content.querySelector(".mappa_marker-label");
      label_string.textContent = participant.name || participant.imei;
      if(MainMapService.popupVisible){
        label_string.style.display = 'unset';
      }else{
        label_string.style.display = 'none';
      }

    }else if(participant.isInFleet()){ // devo aggiungere il marker perchè è nuovo solo se è in flotta
      this.drawSingleParticipantMarker(participant);
    }

    if(MainMapService.autoFollow && !this.autoZoomPausedByUser){
      const now = Date.now();
      if (now - this.lastAutoZoomTime > 10000) { // 10 secondi
        this.resizeMarkerParticipant();
        this.lastAutoZoomTime = now;
      }
    }
  }

  removeParticipantMarker(id: string){
    for(let i=0; i<this.participantMarkers.length; i++){
      if(this.participantMarkers[i].id === id){
        this.googleMaps.removeMarker(this.participantMarkers[i], this.MAP_NAME);
        this.participantMarkers.splice(i, 1);
        return;
      }
    }
  }

  toggleVisibilityLabel(visible: boolean){
    MainMapService.labelVisible = visible;
    for(let marker of this.participantMarkers){
      this.showLabelMarker(marker);
    }
    for(let marker of this.poiMarkers){
      this.showLabelMarker(marker);
    }
  }

  private showLabelMarker(marker: any){
    const etichetta: any = marker.content.querySelector('.mappa_etichetta_number');
    let label_elem = marker.content.querySelector(".mappa_label_number");
    if(!MainMapService.labelVisible){
      label_elem.style.display = 'none';
      etichetta.style.display = 'none';
    }else{
      label_elem.style.display = 'block';
      let div_image = marker.content.querySelector(".mappa_internal_img");
      if(div_image.style.backgroundImage !== 'none'){
        etichetta.style.display = 'block';
      }else{
        etichetta.style.display = 'none';
      }
    }
  }

  toggleVisibilityPopup(visible: boolean){
    MainMapService.popupVisible = visible;
    for(let marker of this.participantMarkers){
      this.showPopupParticipantMarker(marker);
    }
  }

  private showPopupParticipantMarker(marker: any){
    const label_elem: any = marker.content.querySelector(".mappa_marker-label");
    if(MainMapService.popupVisible){
      label_elem.style.display = 'unset';
    }else{
      label_elem.style.display = 'none';
    }
  }

  toggleVisibilityParticipant(participant: Partecipant){
    if(this.infoWindow) this.infoWindow.close();
    for(let marker of this.participantMarkers){
      if(marker.id === participant._id){
        if(participant.hideOnMap){
          if(marker.map){
            marker.map = null;
          }
        }else{
          if(!marker.map){
            marker.map = this.map;
          }
        }
        break;
      }
    }
  }

  selectParticipant(id: string){
    for(let marker of this.participantMarkers){
      if(marker.id === id){
        let position: any = marker.position;
        this.setCenter(position.lat, position.lng);
        if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
        this.onSelectMarker.next({type: 'participant', id: marker.id});
        this.infoWindow.open(this.map, marker);
        return;
      }
    }
  }




  drawPoiMarkers(pois: Poi[]){
    this.poiMarkers = [];
    for(let i=0; i<pois.length; i++){
      this.drawSinglePoiMarker(pois[i]);
    }
  }

  drawSinglePoiMarker(poi: Poi){
    if(poi.position && poi.position.coordinates && poi.position.coordinates.length === 2){
      const coord: any = {
        lat: poi.position.coordinates[1],
        lng: poi.position.coordinates[0]
      };
      let marker: any = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
        zIndex: 1,
        position: coord,
        content: GoogleMapsService.createPoiMarker(poi),
        map: this.map
      });
      marker.id = poi._id;
      marker.type = 'poi';

      this.poiMarkers.push(marker);

      this.updatePoiMarker(poi);
      this.googleMaps.addMarker(marker, this.MAP_NAME);

      marker.addListener('click', (e: any) => {
        e = e.domEvent;
        e.stopPropagation();
        this.closeInfoWindow();
        if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
        let click_in_spider: boolean;
        if(this.googleMaps.markers_in_spider?.find(elem => elem.id === poi._id)){
          click_in_spider = true;
        }
        this.googleMaps.unspiderfyMarkers(MainMapService.popupVisible);
        if(click_in_spider){
          marker.zIndex = 1000;
          this.onSelectMarker.next({type: 'poi', id: marker.id});
          if(!MainMapService.isMobile) this.infoWindow.open(this.map, marker);
          return;
        }else{
          const clickX = e.clientX;
          const clickY = e.clientY;

          this.googleMaps.markers_in_spider = this.getMarkersAtClick(e);
          if (this.googleMaps.markers_in_spider.length > 1) {
            // include anche il marker cliccato
            if(this.googleMaps.markers_in_spider.length > 12) {
              this.googleMaps.spiderfyMoltiMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }else{
              this.googleMaps.spiderfyMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }
          } else {
            this.onSelectMarker.next({type: 'poi', id: marker.id});
            if(!MainMapService.isMobile) this.infoWindow.open(this.map, marker);
          }
        }
      });
    }
  }

  drawCirclePoi(poi: Poi){
    this.removeCirclePoi();
    for(let marker of this.poiMarkers){
      if(marker.id === poi._id){
        this.circle = new GoogleMapsService.google.maps.Circle({
          center: marker.position,
          radius: poi.radius,
          strokeColor: "#2e97f2",
          strokeWeight: 2,
          fillColor: "#2e97f2",
          fillOpacity: 0.15,
          id: 'circle'
        });
        this.googleMaps.addCircle(this.circle, this.MAP_NAME);
        return;
      }
    }
  }

  updatePoiMarker(poi: Poi){
    let marker: any = this.poiMarkers.find((elem: any) => {
      return elem.id === poi._id;
    });
    if(marker){ // Aggiorno il marker del poi
      marker.position = {lat: poi.latitude, lng: poi.longitude};

      // setto immagine se necessario
      const element: any = marker.content.querySelector('.mappa_internal_img');
      if(poi.image){
        element.style.backgroundImage = `url(${poi.image})`;
      }else{
        element.style.backgroundImage = 'none';
      }

      // setto il label number
      const etichetta: any = marker.content.querySelector('.mappa_etichetta_number');
      let label_elem = marker.content.querySelector(".mappa_label_number");
      etichetta.textContent = `${poi.label_number || ''}`;
      label_elem.textContent = `${poi.label_number || ''} `;
      if(!MainMapService.labelVisible || !poi.label_number){
        label_elem.style.display = 'none';
        etichetta.style.display = 'none';
      }else{
        label_elem.style.display = 'block';
        if(poi.image){
          etichetta.style.display = 'block';
        }else{
          etichetta.style.display = 'none';
        }
      }

    }else{ // Aggiungo un nuovo marker del poi
      this.drawSinglePoiMarker(poi);
    }
  }


  removePoiMarker(id: string){
    for(let i=0; i<this.poiMarkers.length; i++){
      if(this.poiMarkers[i].id === id){
        this.googleMaps.removeMarker(this.poiMarkers[i], this.MAP_NAME);
        this.poiMarkers.splice(i, 1);
        return;
      }
    }
  }

  removeCirclePoi(){
    if(this.circle) this.googleMaps.removeCircle(this.circle, this.MAP_NAME);
    this.circle = undefined;
  }

  toggleVisibilityPoi(poi: Poi){
    if(this.infoWindow) this.infoWindow.close();
    for(let marker of this.poiMarkers){
      if(marker.id === poi._id){
        if(poi.hideOnMap){
          if(marker.map){
            this.googleMaps.removeMarker(marker, this.MAP_NAME);
          }
        }else{
          if(!marker.map){
            this.googleMaps.addMarker(marker, this.MAP_NAME);
          }
        }
        return;
      }
    }
  }

  selectPoi(id: string){
    for(let marker of this.poiMarkers){
      if(marker.id === id){
        let position: any = marker.position;
        this.setCenter(position.lat, position.lng);
        this.onSelectMarker.next({type: 'poi', id: marker.id});
        if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
        this.infoWindow.open(this.map, marker);
        return;
      }
    }
  }

  enableAutoFollow(){
    MainMapService.autoFollow = true;
    this.resumeAutoFollow()
    this.resizeMarkerParticipant();
  }

  disableAutoFollow(){
    MainMapService.autoFollow = false;
    this.resumeAutoFollow();
  }

  resizeMarkerParticipant() {
    let bounds: any = new GoogleMapsService.google.maps.LatLngBounds();

    for (let i = 0; i < this.participantMarkers.length; i++) {
      if (this.participantMarkers[i].map) {
        bounds.extend(this.participantMarkers[i].position);
      }
    }

    for (let i = 0; i < this.poiMarkers.length; i++) {
      if (this.poiMarkers[i].map) {
        bounds.extend(this.poiMarkers[i].position);
      }
    }

    if (!bounds.isEmpty()) {
      this.cambioDaCodice = true;
      this.map.fitBounds(bounds, 50);

      setTimeout(() => {
        if (this.map.getZoom() > 16) {
          this.map.setZoom(16);
        }
        this.cambioDaCodice = false;
      }, 500);
    }
  }

  resumeAutoFollow(){
    this.autoZoomPausedByUser = false;
    this.onUpdateAutoFollow.next({pause: false, status: MainMapService.autoFollow});
    //
    this.cambioDaCodice = true;
    this.resizeMarkerParticipant();
    this.closeInfoWindow()
    setTimeout(() => {
      this.cambioDaCodice = false;
    }, 200);
  }

  setCambioDaCodice(value: boolean){
    this.cambioDaCodice = value;
  }
}
